import OrganizationLicense from "./OrganizationLicense";

type OrganizationProps = {
    id: string;
    name: string;
    adminEmails: string[];
    licenses: OrganizationLicense[];
};

export default class Organization {
    id: string;

    name: string;

    adminEmails: string[];

    licenses: OrganizationLicense[];

    constructor({ id, name, adminEmails, licenses }: OrganizationProps) {
        this.id = id;
        this.name = name;
        this.adminEmails = adminEmails;
        this.licenses = licenses;
    }
}
